import { useContext, useRef, useEffect } from 'react';
import { PresenceContext } from '../../context/PresenceContext.mjs';
import { useVisualElementContext } from '../../context/MotionContext/index.mjs';
import { useIsomorphicLayoutEffect } from '../../utils/use-isomorphic-effect.mjs';
import { LazyContext } from '../../context/LazyContext.mjs';
import { MotionConfigContext } from '../../context/MotionConfigContext.mjs';
function useVisualElement(Component, visualState, props, createVisualElement) {
  var parent = useVisualElementContext();
  var lazyContext = useContext(LazyContext);
  var presenceContext = useContext(PresenceContext);
  var reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  var visualElementRef = useRef();
  /**
   * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
   */
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component, {
      visualState: visualState,
      parent: parent,
      props: props,
      presenceId: presenceContext ? presenceContext.id : undefined,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig: reducedMotionConfig
    });
  }
  var visualElement = visualElementRef.current;
  useIsomorphicLayoutEffect(function () {
    visualElement && visualElement.render();
  });
  useEffect(function () {
    if (visualElement && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useIsomorphicLayoutEffect(function () {
    return function () {
      return visualElement && visualElement.notify("Unmount");
    };
  }, []);
  return visualElement;
}
export { useVisualElement };